module.exports = __webpack_public_path__ + "static/img/03_black duo.6cc91c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-2/03_black duo.png
// module id = qb5h
// module chunks = 12